import { Capacitor } from '@capacitor/core';
import { StatusBar } from '@capacitor/status-bar';

/**
 * Native shell (Capacitor WebView): do not draw web content under the status bar.
 * Safe-area env() values in CSS then match the visible webview insets. No-ops in the browser.
 */
export async function initCapacitorShell(): Promise<void> {
  if (!Capacitor.isNativePlatform()) return;
  try {
    await StatusBar.setOverlaysWebView({ overlay: false });
  } catch (err) {
    console.warn('[Capacitor] StatusBar.setOverlaysWebView failed:', err);
  }
}
